export default {
  methods: {
    tercError(field) {
      return !!field;
    }
  },
  computed: {
    isError: {
      get() {
        return !!(this.model ? this.model.$error || this.model.$warnings : false);
      }
    }
  }
};
